import { createContext } from "react";
export var RoleType;
(function(RoleType) {
    RoleType["Admin"] = "Admin";
})(RoleType || (RoleType = {}));
var AuthContext = /*#__PURE__*/ createContext(null);
export var AuthDispatchContext = /*#__PURE__*/ createContext(null);
export default AuthContext;
